import { init, captureException, setTag } from "@sentry/browser";

export function register(): void {
  init({
    dsn: SENTRY_DSN,
    enabled: !DEV,
    release: VERSION,
  });
  setTag("target", BUILD_TARGET);
}

export function capture(error: Error): void {
  if (error.stack) {
    // Replace firefox extension URLs
    error.stack = error.stack.replace(
      /moz-extension:\/\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/g,
      "resource://tabliss-extension",
    );

    // Replace chrome extension URLs
    error.stack = error.stack.replace(
      /chrome-extension:\/\/hipekcciheckooncpjeljhnekcoolahp/g,
      "resource://tabliss-extension",
    );
  }

  captureException(error);
}
